import React, { FC } from 'react'
import styles from '../../styles'
import { makeStyles } from 'tss-react/mui'
import SelectionPane from '../selectionPane/SelectionPane'
import Menu from '../menu/Menu'
import { Grid } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import links from '../../enums/linksEnum'
import { WHITE } from '../../theme'
import SnackBar from '../snackBar/SnackBar'

const GREY_BG_PAGES: string [] = [links.RECHERCHE_OFFRE, '/']

const Layout: FC = () => {
	const location = useLocation()
	const { classes, cx } = useStyles({ pathname: location.pathname })

	const containerClass = cx(
		'App',
		classes.containerStyle
	)

	return (
		<Grid container className={containerClass}>
			<Menu />

			<Grid container className={classes.appFlex}>
				<Grid container item className={classes.selectionPane}>
					<SelectionPane />
				</Grid>
				<Grid container item xs flexDirection="column" overflow="hidden">
					<Outlet />
				</Grid>
			</Grid>
			<SnackBar />
		</Grid>
	)
}

const useStyles = makeStyles<{ pathname: string }>()((theme, { pathname }) => ({
		...styles(theme),
		containerStyle: {
			flexDirection: 'column',
			backgroundColor: GREY_BG_PAGES.includes(pathname) ? theme.palette.blue['5'] : WHITE
		},
		selectionPane: {
			width: 279
		},
		appFlex: {
			flex: 1
		}
	}
))

export default Layout